import { render, staticRenderFns } from "./ModalAddLocation.vue?vue&type=template&id=554fa690&lang=pug&"
import script from "./ModalAddLocation.vue?vue&type=script&lang=js&"
export * from "./ModalAddLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports